import { TSetDealsFilters } from '../types';

/**
 * This clears the deals filter store
 */
export function onClearDealsFilterStoreCallback(set: TSetDealsFilters) {
  return function onUpdateTxnSearchKey() {
    set(() => ({
      dateRange: null,
      orderBy: null,
      searchKey: '',
      selectedAssetGroups: [],
      selectedBrands: [],
      selectedCategory: null,
      selectedDealsFilters: [],
      sortBy: null,
    }));
  };
}
